import CreateResourceContainer from "../containers/CreateResourceContainer";

const CreateResourcePage = () => {
  return (
    <CreateResourceContainer />
  );
};

export default CreateResourcePage;
